import './CameraUploadButton.css';

import React from 'react';

export interface CameraUploadButtonProps {
  onClick: () => void;
  disabled?: boolean;
  ariaLabel?: string;
  className?: string;
}

const CameraUploadButton: React.FC<CameraUploadButtonProps> = ({
  onClick,
  disabled = false,
  ariaLabel = 'Take photo',
  className = '',
}) => (
  <button
    type="button"
    className={['camera-upload-button', className].filter(Boolean).join(' ')}
    onClick={onClick}
    disabled={disabled}
    aria-label={ariaLabel}
  >
    <svg
      className="camera-upload-button-icon"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M5 7h3.1l1.6-2h4.6l1.6 2H19a2 2 0 0 1 2 2v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V9a2 2 0 0 1 2-2z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="12"
        cy="13"
        r="3.5"
        stroke="currentColor"
        strokeWidth="2"
      />
      <circle cx="18" cy="10" r="0.9" fill="currentColor" />
    </svg>
  </button>
);

export default CameraUploadButton;
